import { z } from 'zod';
import { EpisodeStatusSchema } from './procedures';
import { DashboardCountItemSchema, DashboardItemUsageSchema } from './dashboard';

/**
 * Reportes operativos. Agregaciones calculadas en SQL sobre los episodios,
 * filtrables por rango de fechas y otros criterios. Incluye comparativo contra
 * el periodo inmediatamente anterior de la misma duración.
 */

export const ReportsQuerySchema = z.object({
  desde: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  hasta: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  medicoId: z.string().trim().max(40).optional(),
  anestesiologoId: z.string().trim().max(40).optional(),
  entidad: z.string().trim().max(120).optional(),
  tipo: z.string().trim().max(300).optional(),
  estado: EpisodeStatusSchema.optional(),
});
export type ReportsQuery = z.infer<typeof ReportsQuerySchema>;

export const ReportMonthlySchema = z.object({
  mes: z.string(), // 'YYYY-MM'
  count: z.number().int().nonnegative(),
});
export type ReportMonthly = z.infer<typeof ReportMonthlySchema>;

export const ReportSchema = z.object({
  generadoEn: z.string(),
  rango: z.object({
    desde: z.string().nullable(),
    hasta: z.string().nullable(),
  }),
  totales: z.object({
    episodios: z.number().int().nonnegative(),
    cerrados: z.number().int().nonnegative(),
    anulados: z.number().int().nonnegative(),
    pacientesUnicos: z.number().int().nonnegative(),
  }),
  /** Comparativo vs el periodo anterior de igual duración (null si no hay rango). */
  comparativo: z
    .object({
      episodiosPrevios: z.number().int().nonnegative(),
      deltaPct: z.number().nullable(),
    })
    .nullable(),
  porMes: z.array(ReportMonthlySchema),
  porEstado: z.array(DashboardCountItemSchema),
  porTipo: z.array(DashboardCountItemSchema),
  porMedico: z.array(DashboardCountItemSchema),
  porAnestesiologo: z.array(DashboardCountItemSchema),
  porEntidad: z.array(DashboardCountItemSchema),
  rangosEdad: z.array(DashboardCountItemSchema),
  topInsumos: z.array(DashboardItemUsageSchema),
  topMedicamentos: z.array(DashboardItemUsageSchema),
});
export type Report = z.infer<typeof ReportSchema>;
